import type { FaireProductEntity } from "../../entity_types/product";

export const p_kjztncjy5n: FaireProductEntity = {
  token: "p_kjztncjy5n",
  type: "product",
  name: "Gold Plated Cross Pearl Necklace",
  brandToken: "b_y2j497tv82",
  brandName: "The Pretty Jewellery",
  imageUrl:
    "https://cdn.faire.com/fastly/15c5b87331318243408ade74735410b86da879fd2944f96f908d90e6c3f057f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2aef030a3094190eeb8e8ce11810031862852681655bf7632ba70af95fc32e76.jpeg",
  ],
  priceDollars: 6.24,
  description:
    "Natural freshwater pearls\n\nCrystal Cross Pendant\n\n18K gold plated\n\nPearl and crystal and stainless steel materials\n\nPendant size 1CM * 1.8CM\n\nNecklace length 40CM + 5CM",
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:55.335Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
